import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "OrderConfirmReference" }

import axios from "axios";
// @ts-ignore
import store from "../store/index.ts";
import { ref, reactive, computed } from "vue";
import { useRoute } from "vue-router";
import CartNormalLayout from "../components/CartNormalLayout.vue";
import CartMultiLayout from "../components/CartMultiLayout.vue";

//Emitの定義
interface orderType {
  meisaiId: number;
  orderUpdateDate: string;
  toritsugiCd: string;
  toritsugiMei: string;
  toritsugiBansen: string;
  syotenCd: number;
  syotenMei: string;
  syosiCd: number;
  syosiIsbn: number;
  syosiMei: string;
  orderNum: number;
  tantouMei: string;
  tanzaku1: string;
  tanzaku2: string;
  bikou: string;
  status: number;
  selectedMeisaiFlg?: boolean;
  tanzakuFlg?: false;
}

interface orderListType {
  orderId?: number | string;
  orderDate?: string;
  normalCartFlg: boolean;
  orderStatus: number;
  toritsugiCd?: string;
  toritsugiMei?: string;
  toritsugiBansen?: string;
  order_array: orderType[];
}

//propsが渡せないので、下記データを参照する

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderConfirmReference',
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("toggleGlobalHeader");

const $route = useRoute();
let isActiveRenkei = ref<boolean>(false);
let isActiveNormal = ref<boolean>(true);
let isActiveReference = ref<boolean>(true);
let meisaiId = ref<number>(0);

//型定義(仮)
let order_list = reactive<orderListType[]>([
  {
    orderId: 1,
    orderDate: "2022/01/02",
    normalCartFlg: true,
    orderStatus: 2,
    order_array: [
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "100",
        toritsugiMei: "日販",
        toritsugiBansen: "15-L-34",
        syotenCd: 122652,
        syotenMei: "有隣堂大井町",
        syosiCd: 75802020,
        syosiIsbn: 9784758020206,
        syosiMei: "ヲタクに恋は難しい(7) 特装版",
        orderNum: 10,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
        selectedMeisaiFlg: false,
      },
      {
        meisaiId: 2,
        orderUpdateDate: "",
        toritsugiCd: "000",
        toritsugiMei: "(株)トーハン",
        toritsugiBansen: "15-L-34",
        syotenCd: 1,
        syotenMei: "音羽書店",
        syosiCd: 32479837,
        syosiIsbn: 339287397489,
        syosiMei: "ヲタクに恋は難しい(1)",
        orderNum: 20,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
      {
        meisaiId: 3,
        orderUpdateDate: "",
        toritsugiCd: "000",
        toritsugiMei: "(株)トーハン",
        toritsugiBansen: "15-L-34",
        syotenCd: 1,
        syotenMei: "音羽書店",
        syosiCd: 32479837,
        syosiIsbn: 339287397489,
        syosiMei: "ヲタクに恋は難しい(1)",
        orderNum: 30,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 3,
      },
    ],
  },
  {
    orderId: 2,
    orderDate: "2019/07/03",
    normalCartFlg: false,
    orderStatus: 1,
    order_array: [
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "200",
        toritsugiMei: "中央社",
        toritsugiBansen: "S101",
        syotenCd: 75259,
        syotenMei: "芳林堂書店　高田馬場店",
        syosiCd: 75808325,
        syosiIsbn: 9784758083256,
        syosiMei: "アズールレーン びそくぜんしんっ！ (1)",
        orderNum: 10,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
      {
        meisaiId: 2,
        orderUpdateDate: "",
        toritsugiCd: "200",
        toritsugiMei: "中央社",
        toritsugiBansen: "S101",
        syotenCd: 75259,
        syotenMei: "芳林堂書店　高田馬場店",
        syosiCd: 75807957,
        syosiIsbn: 9784758079570,
        syosiMei: "ゆるゆりアンソロジー 10周年記念ver.",
        orderNum: 20,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
      {
        meisaiId: 3,
        orderUpdateDate: "",
        toritsugiCd: "200",
        toritsugiMei: "中央社",
        toritsugiBansen: "S101",
        syotenCd: 75259,
        syotenMei: "芳林堂書店　高田馬場店",
        syosiCd: 75807956,
        syosiIsbn: 9784758079563,
        syosiMei: "ゆるゆり10周年記念本 ゆるゆりX",
        orderNum: 30,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 3,
      },
    ],
  },
  {
    orderId: 3,
    orderDate: "2020/01/16",
    normalCartFlg: true,
    orderStatus: 1,
    order_array: [
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "100",
        toritsugiMei: "日販",
        toritsugiBansen: " D47-14",
        syotenCd: 581305,
        syotenMei: "定】コスモＢＣ",
        syosiCd: 75804643,
        syosiIsbn: 9784758046435,
        syosiMei: "Bad∞End∞Night　上巻",
        orderNum: 10,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
      {
        meisaiId: 2,
        orderUpdateDate: "",
        toritsugiCd: "000",
        toritsugiMei: "(株)トーハン",
        toritsugiBansen: "15-L-34",
        syotenCd: 1,
        syotenMei: "音羽書店",
        syosiCd: 32479837,
        syosiIsbn: 339287397489,
        syosiMei: "ヲタクに恋は難しい(1)",
        orderNum: 20,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
    ],
  },
  {
    orderId: 4,
    orderDate: "2020/05/12",
    normalCartFlg: false,
    orderStatus: 2,
    order_array: [
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "250",
        toritsugiMei: "楽天ＢＮ",
        toritsugiBansen: "4D-K 211",
        syotenCd: 65169,
        syotenMei: "丸善ＡＰ知立店",
        syosiCd: 75803498,
        syosiIsbn: 9784758034982,
        syosiMei: "	宝石商リチャード氏の謎鑑定 （1）",
        orderNum: 10,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
      {
        meisaiId: 2,
        orderUpdateDate: "",
        toritsugiCd: "250",
        toritsugiMei: "楽天ＢＮ",
        toritsugiBansen: "4D-K 211",
        syotenCd: 65169,
        syotenMei: "丸善ＡＰ知立店",
        syosiCd: 75806858,
        syosiIsbn: 9784758068581,
        syosiMei: "かみあり(9)",
        orderNum: 20,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
      {
        meisaiId: 3,
        orderUpdateDate: "",
        toritsugiCd: "000",
        toritsugiMei: "(株)トーハン",
        toritsugiBansen: "15-L-34",
        syotenCd: 1,
        syotenMei: "音羽書店",
        syosiCd: 32479837,
        syosiIsbn: 339287397489,
        syosiMei: "ヲタクに恋は難しい(1)",
        orderNum: 30,
        tantouMei: "担当者A",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 3,
      },
    ],
  },
  {
    orderId: 5,
    orderDate: "2022/10/12",
    normalCartFlg: false,
    orderStatus: 1,
    order_array: [
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "100",
        toritsugiMei: "日販",
        toritsugiBansen: "B63-03",
        syotenCd: 751250,
        syotenMei: "Ｍ＆Ｊ梅田店",
        syosiCd: 75809496,
        syosiIsbn: 9784758094962,
        syosiMei: "虫かぶり姫（７） 青天の羅針盤と春告げ鳥",
        orderNum: 10,
        tantouMei: "担当者B",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 1,
      },
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "100",
        toritsugiMei: "日販",
        toritsugiBansen: "B63-03",
        syotenCd: 751250,
        syotenMei: "Ｍ＆Ｊ梅田店",
        syosiCd: 75809496,
        syosiIsbn: 9784758094962,
        syosiMei: "虫かぶり姫（７） 青天の羅針盤と春告げ鳥",
        orderNum: 10,
        tantouMei: "担当者B",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 2,
      },
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "100",
        toritsugiMei: "日販",
        toritsugiBansen: "B63-03",
        syotenCd: 751250,
        syotenMei: "Ｍ＆Ｊ梅田店",
        syosiCd: 75809496,
        syosiIsbn: 9784758094962,
        syosiMei: "虫かぶり姫（７） 青天の羅針盤と春告げ鳥",
        orderNum: 10,
        tantouMei: "担当者B",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 3,
      },
    ],
  },
  {
    orderId: 6,
    orderDate: "2022/10/12",
    normalCartFlg: true,
    orderStatus: 1,
    order_array: [
      {
        meisaiId: 1,
        orderUpdateDate: "",
        toritsugiCd: "100",
        toritsugiMei: "日販",
        toritsugiBansen: "C07-20",
        syotenCd: 473290,
        syotenMei: " 紀伊國屋埼玉店",
        syosiCd: 75802386,
        syosiIsbn: 99784758024594,
        syosiMei: "悪役令嬢の中の人～断罪された転生者のため（１）",
        orderNum: 10,
        tantouMei: "担当者C",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 3,
      },
      {
        meisaiId: 2,
        orderUpdateDate: "",
        toritsugiCd: "100",
        toritsugiMei: "日販",
        toritsugiBansen: "C07-20",
        syotenCd: 473290,
        syotenMei: " 紀伊國屋埼玉店",
        syosiCd: 75802386,
        syosiIsbn: 99784758024594,
        syosiMei: "悪役令嬢の中の人～断罪された転生者のため（１）",
        orderNum: 30,
        tantouMei: "担当者C",
        tanzaku1: "",
        tanzaku2: "",
        bikou: "",
        status: 2,
      },
    ],
  },
]);

//対象のオーダー情報を取得---------------------------------------------------
if ($route.query.meisaiId !== "0") {
  meisaiId.value = Number($route.query.meisaiId);
}

//オブジェクトの初期値を空設定せずcomputedで定義(型エラー回避)
let selectedOrderList = computed((): orderListType => {
  //orderIdが合致するものを参照
  const result = order_list.filter(
    (order) => order.orderId == $route.params.id
  );
  const resultObj = { ...result[0] };
  return resultObj;
});

//明細データの取得 MEMO:受注照会の検索ができたら実装する
// const getMaisaiData = async()=>{
//   try {
//     console.log(`${store.state.baseUrl}/chumonReference/normalDetails`)
//     const res = await axios.post(
//       `${store.state.baseUrl}/chumonReference/normalDetails`,
//       $route.query.meisaiId,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       }
//     );
//     console.log('res**',res);
//   } catch (error) {
//     console.log(error);
//   }
// }
// getMaisaiData();

order_list.forEach((order) => {
  if (order.orderId == $route.params.id) {
    selectedOrderList.value.order_array.forEach((order: orderType): void => {
      if (order.meisaiId == meisaiId.value) {
        order.selectedMeisaiFlg = true;
      } else {
        order.selectedMeisaiFlg = false;
      }
    });
    if (order.normalCartFlg) {
      isActiveNormal.value = true;
    } else {
      isActiveNormal.value = false;
    }
  }
});
if (selectedOrderList.value.orderStatus == 2) {
  isActiveRenkei.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isActiveNormal))
      ? (_openBlock(), _createBlock(CartNormalLayout, {
          key: 0,
          selectedOrder: _unref(selectedOrderList),
          referenceFlg: _unref(isActiveReference)
        }, null, 8, ["selectedOrder", "referenceFlg"]))
      : (_openBlock(), _createBlock(CartMultiLayout, {
          key: 1,
          selectedOrder: _unref(selectedOrderList),
          referenceFlg: _unref(isActiveReference),
          renkeiFlg: _unref(isActiveRenkei)
        }, null, 8, ["selectedOrder", "referenceFlg", "renkeiFlg"]))
  ]))
}
}

})